import Image from "next/image";
import { SceneTemplate } from "@/lib/utils/lomda/types";
import { t } from "@/lib/localization";

export default function LomdaEditorAvatar({
    templateConfig,
}: {
    templateConfig: SceneTemplate;
}) {
    const avatarConfig = templateConfig.avatar;
    const avatarStyle = avatarConfig
        ? {
              width: `${avatarConfig.size.width}%`,
              height: `${avatarConfig.size.height}%`,
              top: `${avatarConfig.location.y}%`,
              right: `${avatarConfig.location.x}%`,
          }
        : undefined;
    return (
        <div className="absolute overflow-hidden" style={avatarStyle}>
            {/* TODO: Replace with Avatar component(after we implement it)*/}
            <Image
                src="/images/avatar-sample.webp"
                alt={t("lomda.avatar")}
                fill
                className="object-contain h-full"
                priority={true}
            />
        </div>
    );
}
